export default url => () => window.open(url,"_blank") 